import {Image, LazyPicture} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../components/Div.styled';
import useMediaQuery from '../hooks/useMediaQuery';
import TypographyBody from './Typography/TypographyBody';
import TypographyHeading from './Typography/TypographyHeading';

export interface IBannerProps {
  backgroundImage: string;
  title: string;
  carImage: string;
  subTitle?: string;
  titleStrong: string;
  modelText?: string;
  height?: string;
}

export default function BannerSlider({
  modelText,
  backgroundImage,
  title,
  carImage,
  subTitle,
  titleStrong,
  height,
}: IBannerProps) {
  const {isMobile, isDesktop} = useMediaQuery();
  return (
    <Div
      customStyles={{
        position: 'relative',
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        textAlign: 'center',
        paddingTop: 160,
        transformOrigin: 'center bottom',
        height: height ? height : isMobile ? '520px' : '846px',
      }}
    >
      <Div
        maxWidth={isMobile ? '326px' : '800px'}
        margin="0 auto"
        customStyles={{position: 'relative', height: '100%'}}
      >
        {subTitle && (
          <TypographyBody
            size="body"
            style={{
              marginBottom: 16,
            }}
          >
            {subTitle}
          </TypographyBody>
        )}
        <TypographyHeading
          color="white"
          tag="h1"
          size="xXLarge"
          textAlign="center"
        >
          {title}
        </TypographyHeading>
        <TypographyHeading
          color="white"
          tag="h1"
          textAlign="center"
          size="xXLarge"
          bold
        >
          {titleStrong}
        </TypographyHeading>
      </Div>
      <Div
        customStyles={{
          transform: 'translateY(25%)',
          position: 'absolute',
          bottom: 0,
          zIndex: 2,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Div
          maxWidth={'100%'}
          customStyles={{overflow: isMobile ? 'hidden' : 'auto'}}
        >
          <LazyPicture>
            <source srcSet={carImage} media="(min-width: 1440px)" />
            <Image
              src={carImage}
              width={'100%'}
              height={'auto'}
              alt="Car Banner"
              key={'car-banner'}
              style={{
                maxWidth: '100%',
                transformOrigin: `${isMobile ? 'center 70%' : 'center'}`,
                transform: `scale(${isMobile ? '1.2' : 1})`,
              }}
            />
          </LazyPicture>
        </Div>
      </Div>
      {modelText && (
        <Div
          customStyles={{
            justifyContent: 'center',
            position: 'absolute',
            bottom: isMobile ? '25%' : '30%',
            zIndex: 1,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Div
            maxWidth={'100%'}
            customStyles={{overflowX: 'clip', height: '100%'}}
          >
            <LazyPicture>
              <source srcSet={modelText} media="(min-width: 1440px)" />
              <Image
                src={modelText}
                width={'100%'}
                height={'auto'}
                alt="Car Model Text"
                key={'car-model-text'}
                style={{
                  minWidth: isDesktop ? '1100px' : '100%',
                  transform: `scale(${isMobile ? 2 : 1})`,
                }}
              />
            </LazyPicture>
          </Div>
        </Div>
      )}
    </Div>
  );
}
